const PENDING_AUTH_TRACKING_EVENT_KEY = 'tendera:pending-auth-tracking-event';

export const queuePendingAuthTrackingEvent = (eventName, properties = {}) => {
    if (typeof window === 'undefined') return;

    try {
        window.sessionStorage.setItem(PENDING_AUTH_TRACKING_EVENT_KEY, JSON.stringify({
            eventName,
            properties,
            queuedAt: new Date().toISOString()
        }));
    } catch {
        // Tracking is best-effort and should never block authentication redirects.
    }
};

export const consumePendingAuthTrackingEvent = () => {
    if (typeof window === 'undefined') return null;

    try {
        const rawEvent = window.sessionStorage.getItem(PENDING_AUTH_TRACKING_EVENT_KEY);
        window.sessionStorage.removeItem(PENDING_AUTH_TRACKING_EVENT_KEY);
        if (!rawEvent) return null;

        const parsedEvent = JSON.parse(rawEvent);
        if (!parsedEvent?.eventName) return null;
        return parsedEvent;
    } catch {
        try {
            window.sessionStorage.removeItem(PENDING_AUTH_TRACKING_EVENT_KEY);
        } catch {
            // Ignore cleanup failures.
        }
        return null;
    }
};
